import CascadeTabs from './CascadeTabs';

export default CascadeTabs;
